import { calculateLayout, layoutMultiCampaignTasks } from '../../layout';

/**
 * Full multi-campaign Tidy: per-campaign layout, intra-campaign positions, display map with horizontal offsets.
 * @returns {{ allIntraCampaignPositions: Object, allPositionChanges: Array, displayPositions: Object }}
 */
export function computeMultiCampaignFullTidyState(tasks, nodeDimensions) {
  const tasksByCampaign = {};
  tasks.forEach((task) => {
    const cid = task.sourceCampaign?.id || 'unknown';
    if (!tasksByCampaign[cid]) tasksByCampaign[cid] = [];
    tasksByCampaign[cid].push(task);
  });

  const allIntraCampaignPositions = {};
  const allPositionChanges = [];

  Object.entries(tasksByCampaign).forEach(([campId, campaignTasks]) => {
    const layoutResult = calculateLayout(campaignTasks, nodeDimensions);
    const campaignPositions = layoutResult.positions || layoutResult;

    campaignTasks.forEach((task) => {
      const pos = campaignPositions[task.id];
      if (pos && Number.isFinite(pos.x) && Number.isFinite(pos.y)) {
        allIntraCampaignPositions[task.id] = pos;
        allPositionChanges.push({
          taskId: task.id,
          position: pos,
          sourceCampaignId: campId,
        });
      }
    });
  });

  const tasksWithNewPositions = tasks.map((task) => ({
    ...task,
    position: allIntraCampaignPositions[task.id] || { x: 0, y: 0 },
  }));

  const displayPositions = layoutMultiCampaignTasks(tasksWithNewPositions, nodeDimensions);

  return { allIntraCampaignPositions, allPositionChanges, displayPositions };
}
